import { Link, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';

export const MaintenanceMode = () => {
  return (
    <BaseLayout>
      <CenteredLayout sx={{ textAlign: 'center' }}>
        <GoLogo size={74} />
        <Typography
          sx={{
            mb: spacing[2],
            mt: spacing[4]
          }}
          variant='h1'
        >
          We'll be back soon
        </Typography>
        <Typography
          sx={{ mb: spacing[1], fontWeight: 500 }}
          variant='subtitle1'
        >
          GX Go is down for maintenance. <br />
          You’ll be redirected when it’s back online.
        </Typography>

        <Typography sx={{ mb: spacing[2] }}>
          Need assistance? Drop us a line at{' '}
          <Link
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'white' }}
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
        <Button
          component='a'
          href='https://www.general-index.com'
          size='large'
          sx={{
            width: 250
          }}
          target='_blank'
          variant='contained'
        >
          Visit our Website
        </Button>
      </CenteredLayout>
    </BaseLayout>
  );
};
